import Banner, { type BannerProps } from "ds/components/Banner";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

type LearnLimitedAccessBannerProps = Omit<
  BannerProps,
  "variant" | "title" | "children" | "storageKey"
> & {
  storageKey: string;
};

const LearnLimitedAccessBanner = ({ storageKey, ...rest }: LearnLimitedAccessBannerProps) => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return null;
  }

  return (
    <Banner
      {...rest}
      variant="info"
      title="You're exploring with limited access"
      storageKey={storageKey}
    >
      These missions are open to everyone. Some actions may require admin permissions — reach out to
      your admin if you need access.
    </Banner>
  );
};

export default LearnLimitedAccessBanner;
